/// <reference path='../interfaces/interfaces.d.ts' />
'use strict';

angular.module('beneple.orgs', []);


import './controllers/organisation-detail.controller';

import './directives/insurance_contacts_employee_table.directive'

import './services/orgs.services';



// WEBPACK FOOTER //
// ./frontend/scripts/organisation/_module.ts